import { useEffect, useRef, useState } from "react";
import { FiBriefcase, FiChevronDown } from "react-icons/fi";

const CustomDropdown = ({
  value,
  onChange,
  options = [],
  placeholder = "Choose existing company...",
  disabled = false,
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selected = options.find((opt) => opt.value === value);

  return (
    <div className="relative text-sm sm:textbase" ref={ref}>
      {/* Trigger Box */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen(!open)}
        className={`
          w-full px-4 py-3 border rounded-lg text-left  flex items-center justify-between transition-all
          ${
            disabled
              ? "bg-gray-50 text-text-secondary cursor-not-allowed"
              : "bg-white cursor-pointer"
          }
          ${className}
        `}
      >
        <span className={`${!selected ? "text-text-secondary" : ""}`}>
          {selected ? selected.label : placeholder}
        </span>
        <FiChevronDown
          className={`transition-transform ${
            open ? "rotate-180" : ""
          } text-text-secondary`}
        />
      </button>

      {/* Dropdown Menu */}
      {open && !disabled && (
        <div
          className="absolute left-0 mt-2 w-full bg-white rounded-lg shadow-lg border border-gray-200 z-20
          max-h-60 overflow-y-auto animate-in fade-in slide-in-from-top-2"
        >
          {options.length === 0 && (
            <div className="px-4 py-3 text-sm text-text-secondary">
              No companies found
            </div>
          )}

          {options.map((opt) => (
            <div
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`px-4 py-2 flex items-center gap-2 text-sm cursor-pointer hover:bg-blue-50 ${
                opt.value === value ? "bg-blue-100 font-medium" : ""
              }`}
            >
              {opt.logo ? (
                <img
                  src={opt.logo}
                  className="w-8 h-8 rounded-lg object-cover"
                  alt={opt.label}
                />
              ) : (
                <FiBriefcase className="text-gray-400 text-xl" />
              )}
              <div>{opt.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;